import { AppId, createEntityManagementRoutes } from '@lumapps/router';

import { MEDIA_LIBRARY_SCOPE, MEDIA_LIBRARY_PATH } from './constants';

export const { baseRoute: mediaLibraryAdminRoute } = createEntityManagementRoutes({
    slug: MEDIA_LIBRARY_PATH,
    id: MEDIA_LIBRARY_SCOPE,
    appId: AppId.backOffice,
});
